/** * 系统操作日志 */
<template>
	<div v-if="showOperationVisiable">
		<!--列表-->
		<el-table class="lcsj-data-table" :cell-class-name="$moneyCellClass" v-loading="loading" :data="listData" style="width: 100%" border :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }" :row-key="'keyId'">
			<el-table-column prop="rowNumber" label="序号" width="60"></el-table-column>
			<el-table-column prop="apiModule" label="功能模块" width="130"></el-table-column>
			<el-table-column prop="title" label="功能名称" width="130"></el-table-column>
			<el-table-column prop="operatorName" label="操作人" width="130"></el-table-column>
			<el-table-column prop="createTime" label="操作时间" width="180"></el-table-column>
			<el-table-column prop="content" label="操作内容"></el-table-column>
		</el-table>
		<!-- 分页组件 -->
		<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
	</div>
</template>

<script>
import { GetSystemOperationLogListByBusinessKeyId } from "@/api/systemApi.js";

export default {
	data() {
		return {
			pageShow: true,
			loading: false, // 显示加载
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 15,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 15,
				keyId: ""
			},
			operatorList: [],
			listData: [],
			timeData: [],
			columnsData: [],
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "60",
					isKeep: true
				},
				{
					prop: "title",
					label: "事件类型",
					align: "center",
					width: "160",
					isKeep: true
				},
				{
					prop: "apiModule",
					label: "模块",
					align: "center",
					width: "140"
				},
				{
					prop: "operatorName",
					label: "操作人",
					align: "center",
					width: "100"
				},
				{
					prop: "createTime",
					label: "操作时间",
					align: "center",
					width: "170"
				},
				{
					prop: "content",
					label: "操作内容"
				}
			],
			showOperationVisiable: false
		};
	},
	// 注册组件
	components: {},
	/**
	 * 创建完毕
	 */
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
	},
	computed: {},
	/**
	 * 里面的方法只有被调用才会执行
	 */
	methods: {
		// 显示操作日志
		showOperationLog(businessKeyId) {
			this.formInline.keyId = businessKeyId;
			this.showOperationVisiable = true;
			this.getListData();
		},
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		// 查询
		inputChange() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetSystemOperationLogListByBusinessKeyId(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: "暂无数据"
						});
					}
				})
				.catch((err) => {
					this.$message.error("数据加载失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		}
	}
};
</script>

<style scoped>
.year {
	color: var(--app-primary);
	position: absolute;
	left: -166px;
	top: 1px;
}
</style>
